const base = 16;

export default {
  //*-------------------
  //      Base Sizes
  //--------------------*/
  //* This is the single variable that controls them all */
  base,
  remSize: `${base}px`,
  fontName: 'Univers',
  fontNameHeader: 'UniversBlack',

  //* The size of page text  */
  fontSize: '1rem',
  lineHeight: 1.5,
  lineHeightLarge: 2, // not expecting to use

  //*--------------
  //  Page Heading
  //---------------*/
  headerFontWeight: 'bolder',
  headerLineHeight: 48 / 40,
  h1: `${32 / base}rem`,
  h2: `${24 / base}rem`,
  h3: `${20 / base}rem`,
  h4: `${18 / base}rem`,
  h5: `${16 / base}rem`,

  h1Dsktop: `${40 / base}rem`,
  h2Dsktop: `${32 / base}rem`,
  h3Dsktop: `${24 / base}rem`,
  h4Dsktop: `${18 / base}rem`,
  h5Dsktop: `${16 / base}rem`,

  //*-------------------
  //        Sizes
  //--------------------*/
  mini: `${12 / base}rem`,
  tiny: `${13 / base}rem`,
  small: `${14 / base}rem`,
  medium: `${16 / base}rem`,
  large: `${18 / base}rem`,
  big: `${20 / base}rem`,
  huge: `${24 / base}rem`,
  massive: `${28 / base}rem`
};



// WEBPACK FOOTER //
// ./src/styles/text.js